(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[739],{

/***/ 2824:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-card",
      function () {
        return __webpack_require__(286);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputVoucher; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7239);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);







function InputVoucher(param) {
    var isValid = param.isValid, codePromo = param.codePromo, selectedResto = param.selectedResto;
    var handleCheckCoupon = function handleCheckCoupon(coupon) {
        if (couponValue == "") return;
        codePromo(coupon);
        (0,_utils_api__WEBPACK_IMPORTED_MODULE_5__/* .postCheckCoupon */ .w1)({
            code: (0,lodash__WEBPACK_IMPORTED_MODULE_6__.lowerCase)(coupon),
            resto: selectedResto
        }).then(function(res) {
            isValid(res.data);
        });
    };
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), couponValue = ref[0], setCouponValue = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        w: "full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .ua7, {
                label: locale == "id" ? "Tekan Enter setelah mengetik Kupon" : "Press Enter after type the Coupon",
                "aria-label": "A tooltip",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .IIB, {
                    type: "text",
                    py: 6,
                    placeholder: locale == "id" ? "MASUKKAN KODE PROMO" : "INSERT PROMO CODE",
                    color: "black",
                    borderRadius: 0,
                    textAlign: "center",
                    textTransform: "uppercase",
                    _placeholder: {
                        textTransform: "uppercase"
                    },
                    onChange: function(e) {
                        setCouponValue(e.target.value);
                    },
                    onKeyDown: function(e) {
                        if (e.key == "Enter") {
                            handleCheckCoupon(e.currentTarget.value);
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                variant: "solid",
                h: "100%",
                bg: "black",
                color: "white",
                onClick: function() {
                    return handleCheckCoupon(couponValue);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoChevronForwardOutline */ .nQU, {
                    size: 26
                })
            })
        ]
    });
};


/***/ }),

/***/ 286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2175);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(155);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7258);
/* harmony import */ var _components_Input_InputVoucher__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5819);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1914);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7239);
/* harmony import */ var _utils_const__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3026);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(1127);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




















var __N_SSG = true;
function Home(param) {
    var header = param.header, hotelBrands = param.hotelBrands;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)(), query = ref.query, isReady = ref.isReady, push = ref.push, locale = ref.locale, reload = ref.reload, replace = ref.replace;
    var ref1 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_19__/* .useSWRGraphQL */ .f4)('query p_card {\n      products(where: {tagIn: "gift card"}) {\n        nodes {\n          id\n          databaseId\n          slug\n          image {\n            id\n            altText\n            sourceUrl\n          }\n          name\n          ... on VariableProduct {\n            price(format: RAW)\n            regularPrice(format: RAW)\n            id\n            databaseId\n            sku\n            variations {\n              nodes {\n                id\n                databaseId\n                name\n              }\n            }\n          }\n        }\n      }\n  }'), 3), products = ref1[0], isLoading = ref1[1], isError = ref1[2];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), cards = ref2[0], setCards = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(0), variant = ref3[0], setVariant = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), selectedCard = ref4[0], setSelectedCard = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(500000), selectedPrice = ref5[0], setSelectedPrice = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(1), quanitity = ref6[0], setQuantity = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("0"), cardType = ref7[0], setCardtype = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), messages = ref8[0], setMessages = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), isVoucherValid1 = ref9[0], setIsVoucherValid = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), voucher1 = ref10[0], setVoucher = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), total = ref11[0], setTotal = ref11[1];
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (!products) return;
        setCards(products.products.nodes);
        var totalTemp = selectedPrice * quanitity;
        if (isVoucherValid1 && isVoucherValid1.isUsable) {
            var tempDisc = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toNumber)(isVoucherValid1.amount.replace(".00", ""));
            if (isVoucherValid1.discount_type == "percent") {
                setTotal(totalTemp - totalTemp * (tempDisc / 100));
            } else {
                setTotal(totalTemp - tempDisc > 0 ? totalTemp - tempDisc : 0);
            }
        } else {
            setTotal(totalTemp);
        }
    }, [
        products,
        selectedPrice,
        quanitity,
        isVoucherValid1
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        cards && setSelectedCard(cards[0]);
    }, [
        cards
    ]);
    var cardValues = [];
    for(var i1 = 1; i1 <= 30; i1++){
        cardValues.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
            value: i1,
            children: i1
        }, i1));
    }
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), countries = ref12[0], setCounteries = ref12[1];
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        (0,_utils_api__WEBPACK_IMPORTED_MODULE_16__/* .getCountryList */ .Jp)().then(function(res) {
            setCounteries(res.data);
        });
    }, []);
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useFormik */ .TA)({
        initialValues: {
            name: "",
            email: "",
            phone: "",
            country: "Indonesia",
            city: "",
            zip: "",
            street: ""
        },
        validationSchema: yup__WEBPACK_IMPORTED_MODULE_10__/* .object */ .Ry({
            name: yup__WEBPACK_IMPORTED_MODULE_10__/* .string */ .Z_().max(20).required(locale == "id" ? "Harus diisi" : "Required"),
            email: yup__WEBPACK_IMPORTED_MODULE_10__/* .string */ .Z_().email(locale == "id" ? "Email tidak valid" : "Please enter a valid email").required(locale == "id" ? "Harus diisi" : "Required"),
            phone: yup__WEBPACK_IMPORTED_MODULE_10__/* .string */ .Z_().matches(_utils_const__WEBPACK_IMPORTED_MODULE_17__/* .phoneRegExp */ .Oj, locale == "id" ? "Nomor telepon tidak valid" : "Phone must be a valid phone number").required(locale == "id" ? "Harus diisi" : "Required"),
            country: yup__WEBPACK_IMPORTED_MODULE_10__/* .string */ .Z_(),
            city: yup__WEBPACK_IMPORTED_MODULE_10__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            zip: yup__WEBPACK_IMPORTED_MODULE_10__/* .number */ .Rx().required(locale == "id" ? "Harus diisi" : "Required"),
            street: yup__WEBPACK_IMPORTED_MODULE_10__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required")
        }),
        onSubmit: function() // { name, email, message, phone },
        // { setSubmitting, setStatus }
        {}
    });
    function handleClick() {
        return _handleClick.apply(this, arguments);
    }
    function _handleClick() {
        _handleClick = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var _values, email, name, city, country, street, zip, phone;
            return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (formik.isValid) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        formik.setSubmitting(true);
                        _values = formik.values, email = _values.email, name = _values.name, city = _values.city, country = _values.country, street = _values.street, zip = _values.zip, phone = _values.phone;
                        _ctx.next = 6;
                        return (0,_utils_api__WEBPACK_IMPORTED_MODULE_16__/* .postOrder */ .mv)({
                            name: name,
                            email: email,
                            phone: phone,
                            city: city,
                            country: country,
                            street: street,
                            zip: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(zip),
                            price: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(selectedPrice),
                            slug: "parador",
                            coupon: voucher1,
                            items: [
                                {
                                    product_id: selectedCard.databaseId,
                                    quantity: quanitity,
                                    variation_id: selectedCard.variations.nodes[variant].databaseId
                                }, 
                            ],
                            message: {
                                message: messages,
                                type: cardType == "0" ? "digital" : "physical"
                            },
                            type: "card"
                        }).then(function(res) {
                            res.status == 200 && formik.setStatus("success");
                            // setShowPop(true); //COD
                            window.open(res.data.redirect_url, "_self"); //RDP PAYMENT
                        });
                    case 6:
                        formik.setSubmitting(false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handleClick.apply(this, arguments);
    }
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), showPop = ref13[0], setShowPop = ref13[1];
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (!isReady) return;
        if (query.proccess == "succes" || query.transaction_id) {
            if (!query.sig) return;
            (0,_utils_api__WEBPACK_IMPORTED_MODULE_16__/* .getSigMatch */ .Jv)({
                sig: query.sig,
                id: query.id,
                total: query.total
            }).then(function(res) {
                setShowPop(true);
                if (res.data.result) {
                    (0,_utils_api__WEBPACK_IMPORTED_MODULE_16__/* .postOrderLater */ .GK)({
                        id: query.id
                    });
                    setInterval(function() {
                        window.open("/gift-card", "_self");
                    }, 1000);
                }
            });
        }
    }, [
        isReady
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: locale == "id" ? "kartu Hadiah | Parador Hotels & Resorts" : "Gift Card | Parador Hotels & Resorts",
                description: locale == "id" ? "Parador Hotels memiliki toko online yang menyediakan voucher hotel untuk sejumlah hotel dalam grup kami. Dengan parador-hotels.com, Anda dapat dengan mudah menjelajahi berbagai pilihan hotel, memilih lokasi yang Anda inginkan, dan membeli voucher hanya dalam beberapa kali klik. Apapun keperluan Anda, apakah itu liburan mewah, akhir pekan romantis, atau perjalanan bisnis, situs web kami menawarkan berbagai pilihan yang dapat disesuaikan dengan kebutuhan Anda. Nikmati pengalaman belanja yang mudah dan menyenangkan dengan Parador Hotels, di mana kepuasan Anda adalah prioritas utama\xa0bagi\xa0kami." : "Parador Hotels is your go-to online shop for purchasing hotel vouchers for a wide range of hotels within our group. With parador-hotels.com, you'll have access to a convenient platform that allows you to browse through various hotel options, select your preferred location, and purchase vouchers in just a few clicks. Whether you're looking for a luxurious getaway, a romantic weekend, or a business trip, our website offers an extensive range of options to choose from. Enjoy hassle-free shopping with Parador Hotels, where your satisfaction is our\xa0top\xa0priority.",
                image: "https://backend.parador-hotels.com/wp-content/uploads/2023/02/Home-1.webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                headerItem: header,
                hotelBrands: hotelBrands,
                isHomepage: false
            }),
            (showPop || formik.isSubmitting) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                position: "fixed",
                top: 0,
                zIndex: 5,
                bg: "blackAlpha.600",
                h: "100vh",
                w: "100vw",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AbsoluteCenter */ .umj, {
                    w: [
                        "90vw",
                        "70vw",
                        "50vw"
                    ],
                    h: [
                        "60vh",
                        "50vh",
                        "40vh"
                    ],
                    bg: "black",
                    px: 20,
                    borderColor: "white",
                    borderRadius: 0,
                    borderWidth: 10,
                    zIndex: 6,
                    children: formik.isSubmitting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                        w: "100%",
                        h: "100%",
                        gap: 10,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Spinner */ .$jN, {
                            color: "white",
                            size: "xl"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                        w: "100%",
                        h: "100%",
                        flexDir: "column",
                        gap: 10,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                as: "h3",
                                fontWeight: 400,
                                letterSpacing: "widest",
                                fontSize: "xl",
                                textAlign: "center",
                                color: "white",
                                children: "Thank you for purchasing, please check your email for payment"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                    variant: "outline",
                                    color: "white",
                                    _hover: {
                                        opacity: 0.8
                                    },
                                    onClick: function() {
                                        setShowPop(false);
                                    },
                                    children: "CLOSE"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                bg: "white",
                color: "black",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                as: "h1",
                                m: 0,
                                mb: 2,
                                fontWeight: 400,
                                letterSpacing: "widest",
                                color: "black",
                                children: locale == "id" ? "Kartu Hadiah" : "Gift Card"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                m: 0,
                                maxW: {
                                    base: "90%",
                                    md: "50%"
                                },
                                align: "left",
                                color: "blackAlpha.700",
                                children: locale == "id" ? "Nikmati penawaran & promosinya" : "Enjoy the offers & promotions"
                            })
                        ]
                    }),
                    isLoading || !cards || !selectedCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                        h: "50vh",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Spinner */ .$jN, {
                            size: "xl"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                        gap: 8,
                        flexDir: [
                            "column",
                            null,
                            null,
                            "row"
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                flex: 4,
                                flexDir: "column",
                                gap: 10,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                        mb: 10,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                            orientation: "horizontal",
                                            borderColor: "blackAlpha.500"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                        gap: 2,
                                        flexDir: [
                                            "column",
                                            null,
                                            null,
                                            "row"
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                w: [
                                                    "100%",
                                                    null,
                                                    null,
                                                    "50%"
                                                ],
                                                h: "100%",
                                                flexDir: "column",
                                                gap: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        align: "center",
                                                        gap: 4,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                                                                h: 62,
                                                                w: 62,
                                                                borderWidth: 2,
                                                                borderRadius: "50%",
                                                                borderColor: "blackAlpha.600",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: 30,
                                                                    children: "1"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                                fontSize: "2xl",
                                                                letterSpacing: "widest",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Kustomisasi" : "Customize"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        justify: "space-between",
                                                        flexDir: "column",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                letterSpacing: "widest",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                mb: [
                                                                    0,
                                                                    2,
                                                                    4
                                                                ],
                                                                children: locale == "id" ? "Pilih Desain:" : "Select Design:"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                w: "xs",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .PhF, {
                                                                    borderRadius: 0,
                                                                    fontSize: "sm",
                                                                    defaultValue: selectedCard.name,
                                                                    onChange: function(e) {
                                                                        setSelectedCard(cards[e.target.value]);
                                                                    },
                                                                    children: cards.map(function(card, i) {
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                            value: i,
                                                                            children: card.name
                                                                        }, card.name);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                mt: [
                                                    8,
                                                    null,
                                                    null,
                                                    0
                                                ],
                                                w: [
                                                    "100%",
                                                    null,
                                                    null,
                                                    "50%"
                                                ],
                                                h: "100%",
                                                flexDir: "column",
                                                gap: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        align: "center",
                                                        gap: 4,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                                                                h: 62,
                                                                w: 62,
                                                                borderWidth: 2,
                                                                borderRadius: "50%",
                                                                borderColor: "blackAlpha.600",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: 30,
                                                                    children: "2"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                                fontSize: "2xl",
                                                                letterSpacing: "widest",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Pembayaran" : "Checkout"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AspectRatio */ .oM5, {
                                                        ratio: 16 / 9,
                                                        mr: 16,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                            h: "100%",
                                                            w: "100%",
                                                            borderRadius: 16,
                                                            children: selectedCard.image.sourceUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                                src: selectedCard.image.sourceUrl,
                                                                alt: selectedCard.image.alt,
                                                                objectFit: "cover",
                                                                layout: "fill",
                                                                priority: true,
                                                                unoptimized: true
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                bg: "gray.300",
                                                                w: "100%",
                                                                h: "100%"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                        mb: 10,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                            orientation: "horizontal",
                                            borderColor: "blackAlpha.500"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SimpleGrid */ .MIq, {
                                        columns: [
                                            1,
                                            null,
                                            2
                                        ],
                                        rowGap: [
                                            2,
                                            4,
                                            10
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                letterSpacing: "widest",
                                                fontSize: "xl",
                                                textTransform: "uppercase",
                                                fontWeight: 400,
                                                mb: [
                                                    0,
                                                    2,
                                                    4
                                                ],
                                                children: locale == "id" ? "Pilih Nominal" : "Select/Enter a Value"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                flexDir: "column",
                                                gap: 3,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .PhF, {
                                                        borderRadius: 0,
                                                        fontSize: "sm",
                                                        onChange: function(e) {
                                                            var temp = JSON.parse(e.target.value);
                                                            setSelectedPrice(temp.price);
                                                            setVariant(temp.variant);
                                                        },
                                                        defaultValue: 500000,
                                                        children: selectedCard.price.split(",").map(function(p, i) {
                                                            var value = {
                                                                price: p,
                                                                variant: i
                                                            };
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                value: JSON.stringify(value),
                                                                children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_18__/* .formatRupiah */ .b7)(p)
                                                            }, p);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        fontSize: "sm",
                                                        mb: [
                                                            4,
                                                            2
                                                        ],
                                                        color: "blackAlpha.800",
                                                        children: [
                                                            locale == "id" ? "Pilih nominal antara" : "Enter whole amount between",
                                                            " ",
                                                            "Rp500.000 - 2.000.000"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                letterSpacing: "widest",
                                                fontSize: "xl",
                                                textTransform: "uppercase",
                                                fontWeight: 400,
                                                mb: [
                                                    0,
                                                    2,
                                                    4
                                                ],
                                                children: locale == "id" ? "Jumlah" : "Quantity"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                flexDir: "column",
                                                gap: 3,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .PhF, {
                                                        borderRadius: 0,
                                                        fontSize: "sm",
                                                        defaultValue: "1",
                                                        onChange: function(e) {
                                                            setQuantity(e.target.value);
                                                        },
                                                        children: cardValues
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        fontSize: "sm",
                                                        mb: [
                                                            4,
                                                            2
                                                        ],
                                                        color: "blackAlpha.800",
                                                        children: locale == "id" ? "Tambahkan sampai 30 kartu ke orderan anda" : "Add up to 30 cards to your order"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                letterSpacing: "widest",
                                                fontSize: "xl",
                                                textTransform: "uppercase",
                                                fontWeight: 400,
                                                mb: [
                                                    0,
                                                    2,
                                                    4
                                                ],
                                                children: locale == "id" ? "Pesan" : "Message"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                flexDir: "column",
                                                gap: 3,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Textarea */ .gxH, {
                                                        maxLength: 200,
                                                        fontSize: "sm",
                                                        id: "messages",
                                                        name: "messages",
                                                        borderRadius: 0,
                                                        placeholder: locale == "id" ? "Masukkan pesan pribadi.." : "Add your personal message here..",
                                                        onChange: function(e) {
                                                            setMessages(e.target.value);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        fontSize: "sm",
                                                        mb: [
                                                            4,
                                                            2
                                                        ],
                                                        color: "blackAlpha.800",
                                                        children: [
                                                            200 - messages.length,
                                                            " ",
                                                            locale == "id" ? "karakter tersisa." : "Character left."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                letterSpacing: "widest",
                                                fontSize: "xl",
                                                textTransform: "uppercase",
                                                fontWeight: 400,
                                                mb: [
                                                    0,
                                                    2,
                                                    4
                                                ],
                                                children: locale == "id" ? "Tipe Kartu" : "Send as"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .RadioGroup */ .FXm, {
                                                onChange: setCardtype,
                                                value: cardType,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kqy, {
                                                    direction: "row",
                                                    gap: 12,
                                                    color: "blackAlpha.700",
                                                    defaultValue: "0",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Radio */ .Y8K, {
                                                        value: "0",
                                                        children: "Digital"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                            orientation: "horizontal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                        as: "h1",
                                        m: 0,
                                        mb: 2,
                                        fontWeight: 400,
                                        letterSpacing: "widest",
                                        color: "black",
                                        children: locale == "id" ? "Pengiriman" : "Delivery"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Grid */ .rjZ, {
                                        flex: 2,
                                        templateColumns: [
                                            "repeat(2, 1fr)",
                                            null,
                                            "repeat(4, 1fr)"
                                        ],
                                        columnGap: 6,
                                        rowGap: 8,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                                colSpan: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                    justify: "space-between",
                                                    flexDir: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                            htmlFor: "name",
                                                            fontSize: "xl",
                                                            textTransform: "uppercase",
                                                            fontWeight: 400,
                                                            children: locale == "id" ? "Nama*" : "Name*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    id: "name",
                                                                    name: "name",
                                                                    type: "text",
                                                                    borderRadius: 0,
                                                                    placeholder: locale == "id" ? "Nama Anda" : "Your Name",
                                                                    onChange: formik.handleChange,
                                                                    onBlur: formik.handleBlur,
                                                                    value: formik.values.name
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    color: "red.500",
                                                                    mt: 1,
                                                                    children: formik.errors.name
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                                colSpan: 1,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                    justify: "space-between",
                                                    flexDir: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                            htmlFor: "email",
                                                            fontSize: "xl",
                                                            textTransform: "uppercase",
                                                            fontWeight: 400,
                                                            children: "Email*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    id: "email",
                                                                    name: "email",
                                                                    type: "email",
                                                                    borderRadius: 0,
                                                                    placeholder: "Your@email.com",
                                                                    onChange: formik.handleChange,
                                                                    onBlur: formik.handleBlur,
                                                                    value: formik.values.email
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    color: "red.500",
                                                                    mt: 1,
                                                                    children: formik.errors.email
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                                colSpan: 1,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                    justify: "space-between",
                                                    flexDir: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                            htmlFor: "phone",
                                                            fontSize: "xl",
                                                            textTransform: "uppercase",
                                                            fontWeight: 400,
                                                            children: locale == "id" ? "Telepon*" : "Phone*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    id: "phone",
                                                                    name: "phone",
                                                                    type: "tel",
                                                                    borderRadius: 0,
                                                                    placeholder: "0812345",
                                                                    onChange: formik.handleChange,
                                                                    onBlur: formik.handleBlur,
                                                                    value: formik.values.phone
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    color: "red.500",
                                                                    mt: 1,
                                                                    children: formik.errors.phone
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                                colSpan: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                    justify: "space-between",
                                                    flexDir: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                            htmlFor: "country",
                                                            fontSize: "xl",
                                                            textTransform: "uppercase",
                                                            fontWeight: 400,
                                                            children: locale == "id" ? "Negara*" : "Country*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .PhF, {
                                                                    borderRadius: 0,
                                                                    fontSize: "sm",
                                                                    defaultValue: "Indonesia",
                                                                    placeholder: "Indonesia",
                                                                    onChange: function(e) {
                                                                        formik.setValues(_objectSpread({}, formik.values, {
                                                                            country: e.target.value
                                                                        }));
                                                                    },
                                                                    children: countries.map(function(country) {
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                            value: country.code,
                                                                            children: country.name
                                                                        }, country.code);
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    color: "red.500",
                                                                    mt: 1,
                                                                    children: formik.errors.country
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                                colSpan: 1,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                    justify: "space-between",
                                                    flexDir: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                            htmlFor: "city",
                                                            fontSize: "xl",
                                                            textTransform: "uppercase",
                                                            fontWeight: 400,
                                                            children: locale == "id" ? "Kota*" : "City*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    id: "city",
                                                                    name: "city",
                                                                    type: "text",
                                                                    borderRadius: 0,
                                                                    placeholder: "Jakarta",
                                                                    onChange: formik.handleChange,
                                                                    onBlur: formik.handleBlur,
                                                                    value: formik.values.city
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    color: "red.500",
                                                                    mt: 1,
                                                                    children: formik.errors.city
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                                colSpan: 1,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                    justify: "space-between",
                                                    flexDir: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                            htmlFor: "zip",
                                                            fontSize: "xl",
                                                            textTransform: "uppercase",
                                                            fontWeight: 400,
                                                            children: locale == "id" ? "Kode Pos*" : "Zip Code*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    id: "zip",
                                                                    name: "zip",
                                                                    type: "number",
                                                                    borderRadius: 0,
                                                                    placeholder: "000",
                                                                    onChange: formik.handleChange,
                                                                    onBlur: formik.handleBlur,
                                                                    value: formik.values.zip
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    color: "red.500",
                                                                    mt: 1,
                                                                    children: formik.errors.zip
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                                colSpan: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                    justify: "space-between",
                                                    flexDir: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                            htmlFor: "street",
                                                            fontSize: "xl",
                                                            textTransform: "uppercase",
                                                            fontWeight: 400,
                                                            children: locale == "id" ? "Alamat*" : "Street*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    id: "street",
                                                                    name: "street",
                                                                    borderRadius: 0,
                                                                    placeholder: "St. New Y",
                                                                    onChange: formik.handleChange,
                                                                    onBlur: formik.handleBlur,
                                                                    value: formik.values.street
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    color: "red.500",
                                                                    mt: 1,
                                                                    children: formik.errors.street
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                                colSpan: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                    justify: "flex-end",
                                                    flexDir: "column",
                                                    h: "100%",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                                        display: [
                                                            "none",
                                                            null,
                                                            null,
                                                            "block"
                                                        ],
                                                        variant: "dark",
                                                        h: "40px",
                                                        onClick: function() {
                                                            return window.scrollTo({
                                                                top: 100,
                                                                behavior: "smooth"
                                                            });
                                                        },
                                                        disabled: !(formik.isValid && Object.keys(formik.touched).length > 0),
                                                        children: locale == "id" ? "Masukkan Keranjang" : "Add to Cart"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                flexDir: "column",
                                align: "center",
                                maxW: [
                                    "full",
                                    null,
                                    null,
                                    "25%"
                                ],
                                flex: 1,
                                color: "blackAlpha.600",
                                gap: 6,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                        align: "center",
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                                                h: 62,
                                                w: 62,
                                                borderWidth: 2,
                                                borderRadius: "50%",
                                                borderColor: "blackAlpha.600",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_8__/* .IoCartOutline */ .toq, {
                                                    size: 32
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                fontSize: "2xl",
                                                letterSpacing: "widest",
                                                fontWeight: 400,
                                                children: locale == "id" ? "Keranjang" : "Your Cart"
                                            })
                                        ]
                                    }),
                                    isVoucherValid1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                                        bg: isVoucherValid1.isUsable ? "blackAlpha.600" : "red.400",
                                        w: "full",
                                        p: 3,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                            fontSize: "small",
                                            fontWeight: 500,
                                            textTransform: "uppercase",
                                            letterSpacing: "wide",
                                            color: "white",
                                            children: isVoucherValid1.isUsable ? "".concat(locale == "id" ? "Promo dipakai:" : "Promo used:", " ").concat(voucher1) : locale == "id" ? "Kode promo salah" : "Promo code is invalid"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                        flexDir: "column",
                                        borderWidth: 1,
                                        borderRadius: 16,
                                        borderColor: "blackAlpha.200",
                                        w: "100%",
                                        gap: 3,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                pt: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "JUMLAH" : "AMOUNT"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_18__/* .formatRupiah */ .b7)(selectedPrice)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "KUANTITAS" : "QUANTITY"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: quanitity
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "TIPE PENGIRIMAN" : "DELIVERY TYPE"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: "Regular"
                                                    })
                                                ]
                                            }),
                                            isVoucherValid1 && isVoucherValid1.isUsable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                            orientation: "horizontal"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        justify: "space-between",
                                                        fontSize: "xs",
                                                        fontWeight: 500,
                                                        px: 6,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                as: "span",
                                                                children: locale == "id" ? "DISKON" : "DISCOUNT"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                as: "span",
                                                                children: [
                                                                    isVoucherValid1.discount_type == "percent" ? isVoucherValid1.amount.replace(".00", "") : (0,_utils_functions__WEBPACK_IMPORTED_MODULE_18__/* .formatRupiah */ .b7)(isVoucherValid1.amount.replace(".00", "")),
                                                                    isVoucherValid1.discount_type == "percent" && "%"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                mb: -0.2,
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 600,
                                                bg: "blackAlpha.200",
                                                color: "blackAlpha.700",
                                                p: 6,
                                                borderBottomRadius: 15,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: "TOTAL"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_18__/* .formatRupiah */ .b7)(total)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Input_InputVoucher__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        codePromo: function(voucher) {
                                            return setVoucher(voucher);
                                        },
                                        isValid: function(isVoucherValid) {
                                            return setIsVoucherValid(isVoucherValid);
                                        },
                                        selectedResto: 0
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                        bg: "black",
                                        color: "white",
                                        w: "100%",
                                        py: 6,
                                        fontSize: "md",
                                        onClick: handleClick,
                                        disabled: selectedPrice <= 0 || quanitity <= 0 || !formik.isValid || !(Object.keys(formik.touched).length > 0),
                                        children: locale == "id" ? "Pembayaran" : "Checkout"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ }),

/***/ 1082:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,4939,3981,9774,2888,179], function() { return __webpack_exec__(2824); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);